module.exports = __webpack_public_path__ + "static/images/components/UpgradeIcon/images/arrow-2.1d4992c0.png";


//////////////////
// WEBPACK FOOTER
// ./components/UpgradeIcon/images/arrow-2.png
// module id = 2697
// module chunks = 11